export default __webpack_public_path__ + "static/media/23.449999a3.JPG";